(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.createObserver();
    }
    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }
    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }
    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }
    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }
    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }
    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }
    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }
    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ysy-hero-slider"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  var DEFAULT_AUTOPLAY = 5000;

  function YsyHero(root) {
    this.root = root;
    this.slides = Array.prototype.slice.call(root.querySelectorAll('[data-ysy-slide]'));
    this.dots = Array.prototype.slice.call(root.querySelectorAll('[data-ysy-dot]'));
    this.prevBtn = root.querySelector('[data-ysy-prev]');
    this.nextBtn = root.querySelector('[data-ysy-next]');
    this.index = 0;
    this.timer = null;
    this.delay = parseInt(root.getAttribute('data-autoplay'), 10) || DEFAULT_AUTOPLAY;
    this.reduceMotion = window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (this.slides.length === 0) return;
    this.bind();
    this.goTo(0);
    if (this.slides.length > 1) this.start();
  }

  YsyHero.prototype.bind = function () {
    var self = this;
    if (this.nextBtn) this.nextBtn.addEventListener('click', function () { self.next(); self.restart(); });
    if (this.prevBtn) this.prevBtn.addEventListener('click', function () { self.prev(); self.restart(); });
    this.dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        self.goTo(parseInt(dot.getAttribute('data-ysy-dot'), 10));
        self.restart();
      });
    });
    if (window.matchMedia && window.matchMedia('(pointer: fine)').matches) {
      this.root.addEventListener('mouseenter', function () { self.stop(); });
      this.root.addEventListener('mouseleave', function () { self.start(); });
    }
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) self.stop(); else self.start();
    });

    // ---- Swipe tactile (mobile / tablette) ----
    var startX = 0, startY = 0, tracking = false;
    var viewport = this.root.querySelector('.ysy-hero__viewport') || this.root;
    viewport.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) return;
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      tracking = true;
      self.stop();
    }, { passive: true });
    viewport.addEventListener('touchend', function (e) {
      if (!tracking) return;
      tracking = false;
      var t = e.changedTouches[0];
      var dx = t.clientX - startX;
      var dy = t.clientY - startY;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
        if (dx < 0) self.next(); else self.prev();
      }
      self.restart();
    }, { passive: true });
  };

  YsyHero.prototype.goTo = function (i) {
    var total = this.slides.length;
    this.index = (i + total) % total;
    for (var s = 0; s < total; s++) {
      var active = s === this.index;
      this.slides[s].classList.toggle('is-active', active);
      if (active) this.slides[s].removeAttribute('aria-hidden');
      else this.slides[s].setAttribute('aria-hidden', 'true');
    }
    for (var d = 0; d < this.dots.length; d++) {
      var on = d === this.index;
      this.dots[d].classList.toggle('is-active', on);
      this.dots[d].setAttribute('aria-selected', on ? 'true' : 'false');
    }
  };

  YsyHero.prototype.next = function () { this.goTo(this.index + 1); };
  YsyHero.prototype.prev = function () { this.goTo(this.index - 1); };

  YsyHero.prototype.start = function () {
    if (this.slides.length < 2 || this.reduceMotion) return;
    this.stop();
    var self = this;
    this.timer = window.setInterval(function () { self.next(); }, this.delay);
  };
  YsyHero.prototype.stop = function () {
    if (this.timer) { window.clearInterval(this.timer); this.timer = null; }
  };
  YsyHero.prototype.restart = function () { this.stop(); this.start(); };

  function initAll(scope) {
    var roots = (scope || document).querySelectorAll('[data-ysy-hero]');
    Array.prototype.forEach.call(roots, function (root) {
      if (!root.ysyHeroInstance) root.ysyHeroInstance = new YsyHero(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
    document.addEventListener('shopify:block:select', function (e) {
      var root = e.target.closest('[data-ysy-hero]');
      if (!root || !root.ysyHeroInstance) return;
      var slide = e.target.closest('[data-ysy-slide]');
      if (!slide) return;
      var instance = root.ysyHeroInstance;
      var i = instance.slides.indexOf(slide);
      if (i > -1) { instance.stop(); instance.goTo(i); }
    });
    document.addEventListener('shopify:block:deselect', function (e) {
      var root = e.target.closest('[data-ysy-hero]');
      if (root && root.ysyHeroInstance) root.ysyHeroInstance.start();
    });
  }
})();

  } catch(e) { console.error(e); }
})();
})();
